import { render, staticRenderFns } from "./RankingOpenExcludeQDIIMonthly.vue?vue&type=template&id=6f2b95b5&scoped=true&"
import script from "./RankingOpenExcludeQDIIMonthly.vue?vue&type=script&lang=js&"
export * from "./RankingOpenExcludeQDIIMonthly.vue?vue&type=script&lang=js&"
import style0 from "./RankingOpenExcludeQDIIMonthly.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RankingOpenExcludeQDIIMonthly.vue?vue&type=style&index=1&id=6f2b95b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2b95b5",
  null
  
)

component.options.__file = "packages/cb-components-ranking/src/components/rank/RankingOpenExcludeQDIIMonthly.vue"
export default component.exports